import React from "react";
import { API_ROOT } from "../../../baseUrls";
import { connect } from "react-redux";
import { getMindfile } from "../../../state/actions/getDataActions";
import {
  Container,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import ContributorCard from "./ContributorCard";

function ContributorSettings({ user, mindfile }) {
  const contributorsTable = () => {
    const contributors = mindfile.contributors || [];
    const tableRows = contributors
        .filter(contributor => mindfile.owner === contributor.id || contributor.id === user.uid)
        .map(contributor => {
      return (
        <TableRow key={contributor.mid}>
          <TableCell width="22">
            <img
              src={`${API_ROOT}/mindfiles/${contributor.user_mindfile_id}/avatar/thumbnail?size=96`}
              alt="avatar"
            />
          </TableCell>
          <TableCell>
            <ContributorCard
              user={user}
              contributor={contributor}
              authenticity_token={user.authenticity_token}
              isOwner={false}
            />
          </TableCell>
        </TableRow>
      );
    });

    return (
      <TableContainer>
        <Table id="contributorsTable">
          <TableBody>{tableRows}</TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Container>
      <div style={{marginBottom: "1rem"}}>
        <Typography variant="h6">Contributors</Typography>
      </div>
      {contributorsTable()}
    </Container>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
});

const mapDispatchToProps = {
  getMindfile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContributorSettings);
